import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';

import {
  AuthStore,
  DateRangeComponent,
  ErrorAlertComponent,
  FilterButtonComponent,
  ListTitleComponent,
  PaginatorWithLoadMoreComponent,
  PERMISSIONS,
  PillWithCancelComponent,
  RefreshButtonComponent,
} from '@sandbox-platform/shared-ui';

import {
  CommissionPaymentFilterDisplayPill,
  CommissionPaymentFilterDisplayStore,
  CommissionPaymentListStore,
  CommissionPaymentListStoreType,
} from './+state';
import { CommissionPaymentDTO } from '../../../types/commission-payment.types';
import { CommissionPaymentFilterDialogComponent } from './components/commission-payment-filter-dialog.component';
import { CommissionPaymentListTableComponent } from './components/commission-payment-list-table.component';

@Component({
  standalone: true,
  imports: [
    DateRangeComponent,
    ErrorAlertComponent,
    FilterButtonComponent,
    ListTitleComponent,
    PaginatorWithLoadMoreComponent,
    PillWithCancelComponent,
    RefreshButtonComponent,
    CommissionPaymentFilterDialogComponent,
    CommissionPaymentListTableComponent,
  ],
  selector: 'lib-commission-payment-list',
  templateUrl: './commission-payment-list.component.html',
  host: { class: 'block h-full' },
})
export class CommissionPaymentListComponent {
  protected readonly store: CommissionPaymentListStoreType = inject(
    CommissionPaymentListStore
  );
  protected readonly filterDisplayStore = inject(
    CommissionPaymentFilterDisplayStore
  );
  protected readonly authStore = inject(AuthStore);
  private readonly router = inject(Router);

  protected readonly canView = computed(() =>
    this.authStore.hasExpertPermission(
      PERMISSIONS.EXPERT.COMMISSION_PAYMENT_READ
    )
  );

  constructor() {
    this.filterDisplayStore.syncAppliedFilters(this.store.filter());
    this.store.get();
  }

  onFromDateChange(event: Event): void {
    this.store.onFromDateChange(event);
  }

  onToDateChange(event: Event): void {
    this.store.onToDateChange(event);
  }

  onLoadMore(): void {
    this.store.loadMore();
  }

  onRefresh(): void {
    this.store.get();
  }

  onOpenFilterDialog(): void {
    this.filterDisplayStore.openDialog(this.store.filter());
  }

  onCloseFilterDialog(): void {
    this.filterDisplayStore.closeDialog();
  }

  onFiltersApply(): void {
    const filters = this.filterDisplayStore.applyDraft();
    this.store.setFilters(filters);
  }

  onClearFilterPill(pill: CommissionPaymentFilterDisplayPill): void {
    const filters = this.filterDisplayStore.clearAppliedFilter(pill);
    this.store.setFilters(filters);
  }

  onClearAllFilterPills(): void {
    const filters = this.filterDisplayStore.clearAllAppliedFilters();
    this.store.setFilters(filters);
  }

  handleViewPayment(payment: CommissionPaymentDTO): void {
    this.router.navigate(['/commission-payments', payment.id]);
  }

  onSortChange(event: { sortBy: string; sortDirection: 'asc' | 'desc' }): void {
    this.store.setSort(event.sortBy, event.sortDirection);
  }
}
